import { defineComponent as _defineComponent } from 'vue';
import TemplateSummaryPopover from "./TemplateSummaryPopover.vue";
import SelectTemplate from "@/components/ConfigTemplates/SelectTemplate.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'SelectTemplate',
    props: {
        templates: null
    },
    emits: ["onSubmit"],
    setup(__props, { emit }) {
        const selectText = "Select storage location template to create new storage location with. These templates are configured by your Galaxy administrator.";
        async function handleSubmit(templateId) {
            emit("onSubmit", templateId);
        }
        return { __sfc: true, selectText, emit, handleSubmit, TemplateSummaryPopover, SelectTemplate };
    }
});
